// Navegadores internos de otras apps (Discord, WhatsApp, Instagram…): ahí no hay
// notificaciones, la ubicación falla seguido y la página se cierra al salir de la app.
const IN_APP_TOKENS = /Discord|WhatsApp|Instagram|FBAN|FBAV|FB_IAB|FBIOS|Messenger|Line\/|Snapchat|musical_ly|BytedanceWebview|TikTok|LinkedInApp|Twitter|MicroMessenger|Telegram/i

const isInstalledApp = () =>
  window.navigator.standalone === true
  || window.matchMedia?.('(display-mode: standalone)').matches

// Devuelve 'android' o 'ios' si la página está dentro de otra app; null en un navegador normal.
export const detectInAppBrowser = (userAgent = window.navigator.userAgent) => {
  const isAndroidDevice = /Android/i.test(userAgent)
  const isIOSDevice = /iPhone|iPad|iPod/i.test(userAgent)
  if ((!isAndroidDevice && !isIOSDevice) || isInstalledApp()) return null
  const knownApp = IN_APP_TOKENS.test(userAgent)
  // WebView de Android: el user agent lleva "; wv)".
  const androidWebView = isAndroidDevice && /; wv\)/.test(userAgent)
  // En iPhone, Safari y Chrome incluyen "Safari/" en el user agent; las vistas internas no.
  const iosWebView = isIOSDevice && !/Safari\//.test(userAgent)
  if (!knownApp && !androidWebView && !iosWebView) return null
  return isAndroidDevice ? 'android' : 'ios'
}

// Enlace que abre esta misma página en Chrome (en Android, si no está, abre la página normal).
export const chromeUrl = (platform, href = window.location.href) => {
  const url = new URL(href)
  const target = `${url.host}${url.pathname}${url.search}`
  if (platform === 'android') {
    return `intent://${target}#Intent;scheme=https;package=com.android.chrome;S.browser_fallback_url=${encodeURIComponent(href)};end`
  }
  return `googlechromes://${target}`
}
